import { createSlice } from '@reduxjs/toolkit';
import { AUTH_STATUS } from 'common/constants';

const INITIAL_STATE = {
  isAuthorized: AUTH_STATUS.Unauthorized,
  loading: false,
  tokenExpired: false,
  userData: {},
  isError: false,
  errorDetails: {},
  userRole: {},
  userProfile: {}
};

const authSlice = createSlice({
  name: 'auth',
  initialState: INITIAL_STATE,
  reducers: {
    getUserInfo(state) {
      state.loading = true;
      state.isAuthorized = AUTH_STATUS.Pending;
    },
    stopLoading(state) {
      state.loading = false;
    },
    startLoading(state) {
      state.loading = true;
    },
    setUserInfo(state, { payload = {} }) {
      state.isAuthorized = AUTH_STATUS.Authorized;
      state.isError = false;
      state.userData = payload;
      state.loading = false;
    },
    authError(state) {
      state.loading = false;
      state.isAuthorized = AUTH_STATUS.Unauthorized;
    },
    setTokenExpired(state) {
      // state.isAuthorized = AUTH_STATUS.Unauthorized;
      state.tokenExpired = true;
    },

    setError(state, { payload }) {
      if (!payload.isError) {
        state.isError = false;
        state.errorDetails = {};
      } else {
        state.isError = true;
        state.errorDetails = payload.error;
      }
    },
    loginfalse(state) {
      state.isAuthorized = AUTH_STATUS.Authorized;
      state.loading = false;
    },
    getUserRole(state) {
      state.loading = true;
    },
    setUserRole(state, { payload = {} }) {
      state.loading = true;
      state.userRole = payload;
    },
    setUserProfile(state, { payload }) {
      state.userProfile = payload;
    }
  }
});

export const authAction = authSlice.actions;

export default authSlice.reducer;
